module.exports = __webpack_public_path__ + "resources/img/img_moai_main_func.45e647d09ac6ed3a650111b687f53940.png";